<div [class.bg-modal--open]="this.genericRequestPopupIsOpen" class="bg-modal" >
    <div class="modal-contents">
        <div class="modal-contents__top py-2 px-4">
            <div class="fw-normal">Invia la tua richiesta</div>
            <div (click)="this.closeGenPopup()" class="close">+</div>
        </div>

        <form [formGroup]="this.genericRequestForm" class="py-3 px-4 ">
            <p class="intro">Chiedi agli agenti immobiliari esperti <b>{{this.createAgentLabel(this.regione, this.provincia, this.comune, this.zona, this.searchValue)}}</b> quali sono gli immobili che potrebbero soddisfare al meglio le tue richieste.</p>
            <div class="row">
                <div class="col-lg-6 col-md-12 col-sm-12 form-group">
                    <p class="pb-0 mb-0">Nome</p>
                    <input readonly formControlName="name" type="text" class="form-control" placeholder="Nome" name="name">
                </div>
                <div class="col-lg-6 col-md-12 col-sm-12 form-group">
                    <p class="pb-0 mb-0">Cognome</p>
                    <input readonly formControlName="surname" type="text" class="form-control" placeholder="Cognome" name="surname">
                </div>

                <div class="col-lg-6 col-md-12 col-sm-12 form-group">
                    <p class="pb-0 mb-0">Email</p>
                    <input readonly formControlName="email" type="email" class="form-control" placeholder="Email" name="email">
                </div>
                <div class="col-lg-6 col-md-12 col-sm-12 form-group">
                    <p class="pb-0 mb-0">Telefono</p>
                    <input readonly formControlName="phone_number" type="text" class="form-control" placeholder="Telefono" name="phone">
                </div>

                <div class="col-lg-12">
                    <textarea [ngClass]="{ 'redBorder': reqForm.message?.invalid && reqForm.message?.touched }" formControlName="message" class="p-2 mt-2" name="" id="textArea" cols="10" rows="10" required placeholder="Descrivi l'immobile che stai cercando con una descrizione più precisa cosi riceverai offerte più in linea con la tua ricerca (obbligatorio)."></textarea>
                    <small [ngClass]="{'d-none mb-2': reqForm.message?.valid || reqForm.message?.untouched}" class="text-danger">Inserire un messaggio.</small>
                </div>

                <div class="col-12 py-2 ms-4 form-check d-flex align-items-center termCont">
                    <input type="checkbox" class="form-check-input mb-2" id="accepts_terms_and_conditions" formControlName="accepts_terms_and_conditions">
                    <label [class.textRed]="this.formIsSubmit && this.genericRequestForm.controls?.accepts_terms_and_conditions?.invalid"
                        class="form-check-label cursor-pointer mb-0" for="accepts_terms_and_conditions">
                        Ho letto e acconsento le <span [class.redColor]="this.formIsSubmit && this.genericRequestForm.controls?.accepts_terms_and_conditions?.invalid"  (click)="this.main?.linkBlank('/condizioni-uso')" class="fw-600">Condizioni Generali</span> e
                        <span [class.redColor]="this.formIsSubmit && this.genericRequestForm.controls?.accepts_terms_and_conditions?.invalid" (click)="this.main?.linkBlank('/privacy-policy')" class="fw-600">l'Informativa sulla Privacy</span>.
                    </label>
                </div>

                <div class="d-flex justify-content-end align-items-center ctaCont">
                    <div (click)="this.closeGenPopupEvt.emit()" class="btn colorPrimary">
                        No, grazie
                    </div>

                    <button [disabled]="!this.genericRequestForm.valid" (click)="submitGenPopup()" class="btn btn-primary my-2 px-3 ms-4" type="submit">
                        Invia
                        <span *ngIf="loadPopup" class="spinner-border spinner-border-sm me-1"></span>
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>
